"use strict";
/**
 * Created on 06 23 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>Data transfer object encapsulating recalculation inputs related to recalculation of regular price of POS gift. Entity includes POS
 * related attributes because of updating attributes.</p>
 *
 * <p><b>Start date of window validity is needed for recalc. It is not part of this entity, it is common to all items in window.</b></p>
 *
 * @author JMe
 */


var WindowItemPOSPriceRecalcInput =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemPOSPriceRecalcInput, _DomainObject_1$Domai);

  /**
   * @param iId Corresponds to {@link WindowItem.id}.
   * @param attributes Corresponds to {@link WindowItem.posAttributes}. POS gift id should be ensured.
   * @param sites Corresponds to {@link WindowItemSitesData.sites} of {@link WindowItem.sitesData}.
   */
  function WindowItemPOSPriceRecalcInput(iId, attributes, sites) {
    var _this;

    _classCallCheck(this, WindowItemPOSPriceRecalcInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPOSPriceRecalcInput).call(this));
    _this.iId = iId;
    _this.attributes = attributes;
    _this.sites = sites;
    return _this;
  }

  return WindowItemPOSPriceRecalcInput;
}(DomainObject_1.DomainObject);

exports.WindowItemPOSPriceRecalcInput = WindowItemPOSPriceRecalcInput;